// extracted by mini-css-extract-plugin
export default {"pageLayout":"p-z","mainContent":"q-z","activeSidebar":"r-z","columnLayout":"s-z","columnLayoutFill":"t-z","columnLayoutLast":"u-z"};